<template slot-scope="scope">
  <!-- 审计 办理 弹窗 -->
  <div>
    <dialogModel
      title="审计一家"
      subtitle="（订单开始时，会有专门工作人员向你联系，请根据工作人员所需要的材料提供对应的资料）"
      width="1200px"
      :visible.sync="VisibleHandlePro"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <div class="section-row">
            <div class="section-block section-left">
              <div class="section-title">企业信息</div>
              <el-form-item
                label="企业名称："
                prop="companyName"
                :required="true"
              >
                <el-select
                  v-model="ruleForm.companyName"
                  placeholder="请选择企业名称"
                  @change="handelChange"
                  value-key="companyName"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码："
                prop="customerCreditCode"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.customerCreditCode }}</div>
              </el-form-item>
              <el-form-item
                label="法定代表人(负责人)："
                prop="legalPerson"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.legalPerson }}</div>
              </el-form-item>
              <el-form-item
                label="企业类型："
                prop="customerCompanyType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerCompanyType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerCompanyType')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="纳税类型："
                prop="customerTaxType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerTaxType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerTaxType')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="联系电话："
                prop="Telephone"
                :required="true"
              >
                <el-input maxlength="30"
                  v-model="ruleForm.Telephone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </div>

            <div class="section-block section-right">
              <div class="section-title">服务信息</div>
              <el-form-item label="服务类别：" :required="true">
                <el-radio-group v-model="ruleForm.Application">
                  <el-radio
                    v-for="item in ApplicationArr"
                    :key="'app-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审计金额：" :required="true">
                <el-radio-group v-model="ruleForm.Amount">
                  <el-radio
                    v-for="item in AuditAmount"
                    :key="'amt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="审计时长：" :required="true">
                <el-radio-group v-model="ruleForm.Duration">
                  <el-radio
                    v-for="item in AuditDuration"
                    :key="'dur-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

          <div class="section-block section-bottom">
            <div class="remark-row">
              <span class="remark-label">备注：</span>
              <div class="remark-box">
                <el-input
                  type="textarea"
                  class="textarea-lg"
                  placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
                  v-model="ruleForm.textarea"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                  :rows="5"
                >
                </el-input>
              </div>
            </div>
            <el-form-item label="支付方式：">
              <el-radio-group v-model="payType">
                <el-radio
                  v-for="item in payTypeArr"
                  :key="'pay-' + item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="13"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../../Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";
export default {
  props: {
    VisibleHandlePro: {},
    enterprise: {},
    options1: {},
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择 //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 1, name: "个体户" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 4, name: "其他" },
      ], //企业类型选项
      AuditAmount: [
        { id: 0, name: "300w以下" },
        { id: 1, name: "300-1000w" },
        { id: 2, name: "1000w以上" },
      ],
      AuditDuration: [
        { id: 1, name: "1年" },
        { id: 2, name: "2年" },
        { id: 3, name: "3年" },
      ],
      ApplicationArr: [{ id: 28, name: "金额" }], //申请选择数据

      ruleForm: {
        customerCompanyType: null, //企业类型
        customerTaxType: null, //纳税类型
        companyName: "", //企业名称
        customerCreditCode: "", //企业统一信用代码
        customerCompanyAddress: "", //企业地址
        legalPerson: "", //法人

        Application: 28, //0服务类别
        Amount: 0, //审计金额
        Duration: 1, //审计时长

        Telephone: "", //联系电话
        textarea: "", //备注
      }, // 注销数据绑定
      rules: {
        // 规则未完善
        customerCompanyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        customerTaxType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        companyName: [
          { required: true, message: " ", trigger: ["blur", "change"] },
        ],
        customerCreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        legalPerson: [
          {
            required: true,
            message: "法人姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        Telephone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
      },

      options: [{ label: "xx", value: "1" }], //公司选择
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    VisibleHandlePro: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            customerCompanyType: null, //企业类型
            customerTaxType: null, //纳税类型
            companyName: "", //企业名称
            customerCreditCode: "", //企业统一信用代码
            customerCompanyAddress: "", //企业地址
            legalPerson: "", //法人

            Application: 28, //0服务类别
            Amount: 0, //审计金额
            Duration: 1, //审计时长

            Telephone: "", //联系电话
            textarea: "", //备注
          }; //填写的内容
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 10);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    //选择购买方
    handelChange(val) {
      this.EnterpriseIsItOptional= true //企业类型是否可选
      this.PayTaxesIsItOptional =  true //纳税类型是否可选
      console.log(val, this.ruleForm.Purchaser, "val");
      this.ruleForm.companyName = val.companyName;
      this.ruleForm.customerCreditCode = val.customerCreditCode;
      this.ruleForm.legalPerson = val.legalPerson;
      this.ruleForm.Telephone = val.phone;
      this.ruleForm.customerCompanyType = val.customerCompanyType;
      this.ruleForm.customerTaxType = val.customerTaxType;
      this.ruleForm.customerCompanyAddress = val.customerCompanyAddress;
      this.$refs.ruleForm.clearValidate();
      if (val.customerCompanyType !== null && val.customerCompanyType !== "") {
        // 自动选中企业类型，不可在修改
        this.EnterpriseIsItOptional = false;
      }
      if (val.customerTaxType !== null && val.customerTaxType !== "") {
        // 自动选中纳税类型，不可在修改
        this.PayTaxesIsItOptional = false;
      }
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseHandlePro");
    },
    // 确认
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (localStorage.getItem("PaymentPwd") == "false") {
            //没有开启支付密码验证直接弹支付二维码
            this.handleUnderstandPwd();
          } else {
            // 支付密码验证
            this.VisiblePwd = true;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      var data = {
        data: {
          businessType: "AUDIT",
          payMethod: this.payType,
          password: pwd,
          businessInfo: {
            businessData: [
              {
                businessType: this.ruleForm.Application,
                customerName: this.ruleForm.companyName,
                customerCreditCode: this.ruleForm.customerCreditCode,
                customerLegalPerson: this.ruleForm.legalPerson,
                customerPhone: this.ruleForm.Telephone,
                customerCompanyAddress: this.ruleForm.customerCompanyAddress,
                // customerCompanyAddressCode: "411303",
                // price: "4.80",
                auditAmount: this.ruleForm.Amount,
                auditDuration: this.ruleForm.Duration,
                customerTaxType: this.ruleForm.customerTaxType,
                customerCompanyType: this.ruleForm.customerCompanyType,
                remark: this.ruleForm.textarea,
              },
            ],
          },
        },
      };
      pay(data).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          this.VisiblePwd = false;
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          // this.$emit("handleConfirmUp");
          // 打开二维码弹窗
          this.VisiblePayment = true;
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../Bookkeeping/components/bookkeeping-form-dialog.less";
</style>
